"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.baseTheme = exports.ThemeType = void 0;
var tokens_1 = __importDefault(require("./color/tokens"));
var tokens_2 = require("./layout/tokens");
var theme_1 = require("./typography/theme");
var tokens_3 = require("./typography/tokens");
var ThemeType;
(function (ThemeType) {
    ThemeType["LIGHT_THEME"] = "light-theme";
    ThemeType["DARK_THEME"] = "dark-theme";
})(ThemeType = exports.ThemeType || (exports.ThemeType = {}));
exports.baseTheme = {
    layout: {
        breakpoints: tokens_2.Breakpoints,
        borderRadii: tokens_2.BorderRadii,
        grid: {
            gutters: tokens_2.GridGutters
        }
    },
    typography: __assign(__assign({}, theme_1.typeStyles), { fontFamilies: tokens_3.FontFamilies, fontSizes: tokens_3.FontSizes, fontWeights: {
            regular: tokens_3.FontWeights.fontWeight400,
            medium: tokens_3.FontWeights.fontWeight500,
            semiBold: tokens_3.FontWeights.fontWeight600,
            bold: tokens_3.FontWeights.fontWeight700,
            extrabold: tokens_3.FontWeights.fontWeight800
        }, lineHeights: tokens_3.LineHeights }),
    colors: {
        /**
         * These colors are not semantic and so will not adapt to light and dark mode!
         * Only use them if the color you need will not change between modes.
         */
        staticPalette: {
            aqua: {
                aqua1: tokens_1["default"].aqua1,
                aqua6: tokens_1["default"].aqua6,
                aqua7: tokens_1["default"].aqua7
            },
            blue: {
                blue100: tokens_1["default"].blue100,
                blue200: tokens_1["default"].blue200,
                blue300: tokens_1["default"].blue300,
                blue400: tokens_1["default"].blue400,
                blue500: tokens_1["default"].blue500,
                blue600: tokens_1["default"].blue600,
                blue700: tokens_1["default"].blue700,
                blue800: tokens_1["default"].blue800,
                blue900: tokens_1["default"].blue900,
                blue1: tokens_1["default"].blue1,
                blue6: tokens_1["default"].blue6,
                blue7: tokens_1["default"].blue7
            },
            kiwi: {
                kiwi100: tokens_1["default"].kiwi100,
                kiwi200: tokens_1["default"].kiwi200,
                kiwi300: tokens_1["default"].kiwi300,
                kiwi400: tokens_1["default"].kiwi400,
                kiwi500: tokens_1["default"].kiwi500,
                kiwi600: tokens_1["default"].kiwi600,
                kiwi700: tokens_1["default"].kiwi700,
                kiwi800: tokens_1["default"].kiwi800,
                kiwi900: tokens_1["default"].kiwi900
            },
            green: {
                green1: tokens_1["default"].green1,
                green6: tokens_1["default"].green6,
                green7: tokens_1["default"].green7
            },
            lime: {
                lime100: tokens_1["default"].lime100,
                lime200: tokens_1["default"].lime200,
                lime300: tokens_1["default"].lime300,
                lime400: tokens_1["default"].lime400,
                lime500: tokens_1["default"].lime500,
                lime600: tokens_1["default"].lime600,
                lime700: tokens_1["default"].lime700,
                lime800: tokens_1["default"].lime800,
                lime900: tokens_1["default"].lime900
            },
            orange: {
                orange100: tokens_1["default"].orange100,
                orange200: tokens_1["default"].orange200,
                orange300: tokens_1["default"].orange300,
                orange400: tokens_1["default"].orange400,
                orange500: tokens_1["default"].orange500,
                orange600: tokens_1["default"].orange600,
                orange700: tokens_1["default"].orange700,
                orange800: tokens_1["default"].orange800,
                orange900: tokens_1["default"].orange900,
                orange1: tokens_1["default"].orange1,
                orange4: tokens_1["default"].orange4,
                orange5: tokens_1["default"].orange5
            },
            purple: {
                purple1: tokens_1["default"].purple1,
                purple6: tokens_1["default"].purple6,
                purple7: tokens_1["default"].purple7,
                purple9: tokens_1["default"].purple9
            },
            pink: {
                pink1: tokens_1["default"].pink1,
                pink6: tokens_1["default"].pink6,
                pink7: tokens_1["default"].pink7
            },
            red: {
                red6: tokens_1["default"].red6
            },
            yellow: {
                yellow1: tokens_1["default"].yellow1,
                yellow4: tokens_1["default"].yellow4,
                yellow5: tokens_1["default"].yellow5
            },
            black: tokens_1["default"].black,
            white: tokens_1["default"].white,
            transparent: tokens_1["default"].transparent,
            salmon: tokens_1["default"].salmon,
            amber: tokens_1["default"].amber,
            leather: tokens_1["default"].leather,
            water: tokens_1["default"].water,
            burnt: tokens_1["default"].burnt,
            bluish: tokens_1["default"].bluish,
            indigo: tokens_1["default"].indigo,
            grass: tokens_1["default"].grass,
            magicMint: tokens_1["default"].magicMint,
            mint: tokens_1["default"].mint,
            topaz: tokens_1["default"].topaz,
            plum: tokens_1["default"].plum,
            cornflower: tokens_1["default"].cornflower,
            redish: tokens_1["default"].redish
        }
    }
};
